<template>
  <RevSkeleton height="96px" shape="rectangle" width="100%" />
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
